import { isUndefinedOrNull } from "../utils/utils"
import { cleanupPolygon } from "./cleanup"
import { getPolygonsAsArray } from "./utils"
import { ol_geom } from "@omnia/exports/openlayers";

export const MinimumZoneArea: number = 10

export function checkGeomTypeAndArea(geom: any, minimumArea: number = MinimumZoneArea) {

    return (geom
        && geom.getType
        && (geom.getType() == "Polygon")
        && geom.getArea
        && ((!minimumArea) || (geom.getArea() >= minimumArea))
    )

}

export function getPolygons(geom: ol_geom.Geometry, minimumArea?: number, sort: boolean = true): ol_geom.Polygon[] {

    if (!geom) return []

    minimumArea = isUndefinedOrNull(minimumArea) ? MinimumZoneArea : minimumArea

    let parts = getPolygonsAsArray([geom])
        .filter(s => checkGeomTypeAndArea(s, minimumArea))
        .map(cleanupPolygon)
        .filter(p => !!p)

    if (sort && (parts.length > 1)) {
        parts = parts.sort((p1, p2) => p2.getArea() - p1.getArea())
    }

    return parts

}

export function getLargestPolygon(geom: ol_geom.Geometry, minimumArea: number = MinimumZoneArea): ol_geom.Geometry {

    let parts = getPolygons(geom, minimumArea)

    if (parts.length > 0) {
        return parts[0];
    }

}
